namespace SorAraBul.PropertyManagement {
    export interface TenantDetailHasoProcessResponse extends Serenity.ServiceResponse {
        Status?: string;
        Message?: string;
        KkbRefNo?: string;
        CustomerId?: string;
        ErrorMessages?: string[];
    }
}
